import { Chip, Grid } from "@mui/material";
import { useRecordContext } from "react-admin";
import PropTypes from "prop-types";

const Tags = ({ setOpen, setTag, setQuote }) => {
  const record = useRecordContext();
  const isAdmin = localStorage.getItem("permissions").includes("ROLE_ADMIN");
  const handleClick = (tag) => {
    setQuote(record.id);
    setTag(tag);
    setOpen(true);
  };

  const Tag = ({ tag }) => {
    if (tag.hidden && !isAdmin) return;
    return (
      <Grid item>
        <Chip
          label={tag.tagName}
          color="primary"
          onDelete={
            isAdmin ||
            tag.tagName !== "NO COVERAGE" ||
            tag.tagName !== "PAP NO COVERAGE"
              ? () => handleClick(tag["@id"])
              : undefined
          }
        />
      </Grid>
    );
  };

  return (
    <Grid container spacing={1}>
      {record.tags.map((tag, index) => {
        return <Tag tag={tag} key={index} />;
      })}
    </Grid>
  );
};

Tags.propTypes = {
  setOpen: PropTypes.func,
  setQuote: PropTypes.func,
  setTag: PropTypes.func,
  tag: PropTypes.any,
  index: PropTypes.number,
};

export default Tags;
